import Colors from './Colors';
import Typography from './Typography';

export {
  Colors, Typography,
};


// WEBPACK FOOTER //
// ./src/views/framework/Theme/index.js